import React, {useEffect, useRef, useState} from 'react';
import {ProgressBar} from 'primereact/progressbar';
import {Menu} from 'primereact/menu';
import {DashboardService} from '../services/DashboardService';
import {Column} from 'primereact/column';
import {DataTable} from 'primereact/datatable';
import {Tag} from "primereact/tag";
import {Button} from "primereact/button";
import {Chart} from "primereact/chart";

const overviewChartData1 = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September'],
    datasets: [
        {
            data: [50, 64, 32, 24, 18, 27, 20, 36, 30],
            borderColor: [
                '#4DD0E1',
            ],
            backgroundColor: [
                'rgba(77, 208, 225, 0.8)',
            ],
            borderWidth: 2,
            fill: true
        }
    ]
};

const overviewChartData2 = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September'],
    datasets: [
        {
            data: [11, 30, 52, 35, 39, 20, 14, 18, 29],
            borderColor: [
                '#4DD0E1',
            ],
            backgroundColor: [
                'rgba(77, 208, 225, 0.8)',
            ],
            borderWidth: 2,
            fill: true
        }
    ]
};

const overviewChartData3 = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September'],
    datasets: [
        {
            data: [20, 29, 39, 36, 45, 24, 28, 20, 15],
            borderColor: [
                '#4DD0E1',
            ],
            backgroundColor: [
                'rgba(77, 208, 225, 0.8)',
            ],
            borderWidth: 2,
            fill: true
        }
    ]
};

const overviewChartData4 = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September'],
    datasets: [
        {
            data: [30, 39, 50, 21, 33, 18, 10, 24, 20],
            borderColor: [
                '#4DD0E1',
            ],
            backgroundColor: [
                'rgba(77, 208, 225, 0.8)',
            ],
            borderWidth: 2,
            fill: true
        }
    ]
};

const overviewChartOptions = {
    legend: {
        display: false
    },
    responsive: true,
    scales: {
        yAxes: [{
            display: false
        }],
        xAxes: [{
            display: false
        }]
    },
    tooltips: {
        enabled: false
    },
    elements: {
        point: {
            radius: 0
        }
    },
};

const ordersChart = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September'],
    datasets: [{
        label: 'New Orders',
        data: [31, 83, 69, 29, 62, 25, 59, 26, 46],
        borderColor: [
            '#4DD0E1',
        ],
        backgroundColor: [
            'rgba(77, 208, 225, 0.8)',
        ],
        borderWidth: 2,
        fill: true
    }, {
        label: 'Completed Orders',
        data: [67, 98, 27, 88, 38, 3, 22, 60, 56],
        borderColor: [
            '#3F51B5',
        ],
        backgroundColor: [
            'rgba(63, 81, 181, 0.8)',
        ],
        borderWidth: 2,
        fill: true,
    }]
};

const getOrdersOptions = () => {
    const textColor = getComputedStyle(document.body).getPropertyValue('--text-color') || 'rgba(0, 0, 0, 0.87)';
    const gridLinesColor = getComputedStyle(document.body).getPropertyValue('--divider-color') || 'rgba(160, 167, 181, .3)';
    const fontFamily = getComputedStyle(document.body).getPropertyValue('--font-family');
    return {
        legend: {
            display: true,
            labels: {
                fontFamily,
                fontColor: textColor,
            }
        },
        responsive: true,
        scales: {
            yAxes: [{
                ticks: {
                    fontFamily,
                    fontColor: textColor
                },
                gridLines: {
                    color: gridLinesColor
                }
            }],
            xAxes: [{
                ticks: {
                    fontFamily,
                    fontColor: textColor
                },
                gridLines: {
                    color: gridLinesColor
                }
            }]
        }
    }
}

let ordersOptions = getOrdersOptions();
let chartMonthlyData;
let chartMonthlyOptions;
let doughnutData;
let doughnutOptions;


export const DashboardDefault = (props) => {
    const [transactions, setTransactions] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);

    const menuRevenues = useRef(null);
    const menuTransactions = useRef(null);
    const menuGraph = useRef(null);
    const doughnut = useRef(null);
    const bar = useRef(null);

    useEffect(() => {
        const productService = new DashboardService();
        productService.getTransactions().then(data => setTransactions(data));
        ordersOptions = getOrdersOptions();
        setOverviewColors()
        chartMonthlyData = getChartData('light');
        chartMonthlyOptions = getChartOptions();
        doughnutData = getDoughnutData('light');
        doughnutOptions = getDoughnutOptions();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const getOverviewColors = () => {
        const isLight = true;
        return {
            pinkBorderColor: isLight ? '#E91E63' : '#EC407A',
            pinkBgColor: isLight ? '#F48FB1' : '#F8BBD0',
            tealBorderColor: isLight ? '#009688' : '#26A69A',
            tealBgColor: isLight ? '#80CBC4' : '#B2DFDB'
        }
    }

    const getDoughnutData = (colorMode) => {
        const {
            blueColor, lightblueColor, cyanColor, tealColor, greenColor,
            lightgreenColor, orangeColor
        } = getColors(colorMode);
        const borderColor = getComputedStyle(document.body).getPropertyValue('--divider-color') || 'rgba(160, 167, 181, .3)';

        return {
            labels: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            datasets: [
                {
                    data: [11, 29, 71, 33, 28, 95, 6],
                    backgroundColor: [blueColor, lightblueColor, cyanColor, tealColor, greenColor, lightgreenColor, orangeColor],
                    borderColor
                }
            ]
        };
    }

    const getDoughnutOptions = () => {
        const textColor = getComputedStyle(document.body).getPropertyValue('--text-color') || 'rgba(0, 0, 0, 0.87)';
        const fontFamily = getComputedStyle(document.body).getPropertyValue('--font-family');
        return {
            responsive: true,
            legend: {
                position: 'top',
                labels: {
                    fontFamily,
                    fontColor: textColor
                }
            },
            circumference: Math.PI,
            rotation: -Math.PI,
            animation: {
                animateScale: true,
                animateRotate: true
            }
        };
    }


    const setOverviewColors = () => {
        const {pinkBorderColor, pinkBgColor, tealBorderColor, tealBgColor} = getOverviewColors();

        overviewChartData1.datasets[0].borderColor[0] = tealBorderColor;
        overviewChartData1.datasets[0].backgroundColor[0] = tealBgColor;

        overviewChartData2.datasets[0].borderColor[0] = tealBorderColor;
        overviewChartData2.datasets[0].backgroundColor[0] = tealBgColor;

        overviewChartData3.datasets[0].borderColor[0] = pinkBorderColor;
        overviewChartData3.datasets[0].backgroundColor[0] = pinkBgColor;

        overviewChartData4.datasets[0].borderColor[0] = tealBorderColor;
        overviewChartData4.datasets[0].backgroundColor[0] = tealBgColor;
    }

    const getColors = (colorMode) => {
        const isLight = colorMode === 'light';
        return {
            pinkColor: isLight ? '#EC407A' : '#F48FB1',
            purpleColor: isLight ? '#AB47BC' : '#CE93D8',
            deeppurpleColor: isLight ? '#7E57C2' : '#B39DDB',
            indigoColor: isLight ? '#5C6BC0' : '#9FA8DA',
            blueColor: isLight ? '#42A5F5' : '#90CAF9',
            lightblueColor: isLight ? '#29B6F6' : '#81D4FA',
            cyanColor: isLight ? '#00ACC1' : '#4DD0E1',
            tealColor: isLight ? '#26A69A' : '#80CBC4',
            greenColor: isLight ? '#66BB6A' : '#A5D6A7',
            lightgreenColor: isLight ? '#9CCC65' : '#C5E1A5',
            limeColor: isLight ? '#D4E157' : '#E6EE9C',
            yellowColor: isLight ? 'FFEE58' : '#FFF59D',
            amberColor: isLight ? '#FFCA28' : '#FFE082',
            orangeColor: isLight ? '#FFA726' : '#FFCC80',
            deeporangeColor: isLight ? '#FF7043' : '#FFAB91',
            brownColor: isLight ? '#8D6E63' : '#BCAAA4'
        }
    }

    const getChartData = (colorMode) => {
        const {
            limeColor, amberColor, orangeColor, blueColor, lightblueColor,
            cyanColor, tealColor, greenColor, lightgreenColor
        } = getColors(colorMode);

        return {
            labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
            datasets: [
                {
                    label: '2012',
                    data: [6, 25, 97, 12, 7, 70, 42],
                    borderColor: blueColor,
                    backgroundColor: blueColor,
                    borderWidth: 2,
                    fill: true
                },
                {
                    label: '2013',
                    data: [81, 3, 5, 11, 59, 47, 99],
                    borderColor: lightblueColor,
                    backgroundColor: lightblueColor,
                    borderWidth: 2,
                    fill: true
                },
                {
                    label: '2014',
                    data: [68, 47, 46, 46, 61, 70, 94],
                    borderColor: cyanColor,
                    backgroundColor: cyanColor,
                    borderWidth: 2,
                    fill: true
                },
                {
                    label: '2015',
                    data: [31, 9, 18, 76, 6, 11, 79],
                    borderColor: tealColor,
                    backgroundColor: tealColor,
                    borderWidth: 2,
                    fill: true
                },
                {
                    label: '2016',
                    data: [85, 37, 47, 29, 2, 10, 54],
                    borderColor: greenColor,
                    backgroundColor: greenColor,
                    borderWidth: 2,
                    fill: true
                },
                {
                    label: '2017',
                    data: [28, 48, 40, 19, 86, 27, 90],
                    borderColor: lightgreenColor,
                    backgroundColor: lightgreenColor,
                    borderWidth: 2,
                    fill: true
                },
                {
                    label: '2018',
                    data: [89, 18, 95, 18, 97, 61, 54],
                    borderColor: limeColor,
                    backgroundColor: limeColor,
                    borderWidth: 2,
                    fill: true
                },
                {
                    label: '2019',
                    data: [18, 36, 39, 58, 41, 50, 72],
                    borderColor: amberColor,
                    backgroundColor: amberColor,
                    borderWidth: 2,
                    fill: true
                },
                {
                    label: '2020',
                    data: [31, 4, 35, 74, 47, 35, 46],
                    borderColor: orangeColor,
                    backgroundColor: orangeColor,
                    borderWidth: 2,
                    fill: true
                }
            ]
        };
    }

    const getChartOptions = () => {
        const textColor = getComputedStyle(document.body).getPropertyValue('--text-color') || 'rgba(0, 0, 0, 0.87)';
        const gridLinesColor = getComputedStyle(document.body).getPropertyValue('--divider-color') || 'rgba(160, 167, 181, .3)';
        const fontFamily = getComputedStyle(document.body).getPropertyValue('--font-family');
        return {
            legend: {
                display: true,
                labels: {
                    fontFamily,
                    fontColor: textColor
                }
            },
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                yAxes: [{
                    ticks: {
                        fontFamily,
                        fontColor: textColor
                    },
                    gridLines: {
                        color: gridLinesColor
                    }
                }],
                xAxes: [{
                    categoryPercentage: .9,
                    barPercentage: .8,
                    ticks: {
                        fontFamily,
                        fontColor: textColor
                    },
                    gridLines: {
                        color: gridLinesColor
                    }
                }]
            },
            animation: {
                animateScale: true,
                animateRotate: true
            }
        }
    }

    const changeMonthlyDataView = () => {
        if (bar.current.chart.options.scales.xAxes[0].stacked) {
            bar.current.chart.options.scales.xAxes[0].stacked = false;
            bar.current.chart.options.scales.yAxes[0].stacked = false;
        } else {
            bar.current.chart.options.scales.xAxes[0].stacked = true;
            bar.current.chart.options.scales.yAxes[0].stacked = true;
        }

        bar.current.chart.update();
    }

    const priceBodyTemplate = (data) => {
        return (
            <>
                <span className="p-column-title">Montant</span>
                {formatCurrency(data.price)}
            </>
        );
    };

    const statusBodyTemplate = (data) => {
        let component;
        if ("PENDING" === data.status) {
            component = <Tag severity="info" value={data.status} outlined></Tag>
        } else if ("COMPLETED" === data.status) {
            component = <Tag severity="success" value={data.status}></Tag>
        } else if ("FAILED" === data.status) {
            component = <Tag severity="danger" value={data.status}></Tag>
        } else if ("CANCELLED" === data.status) {
            component = <Tag className="p-tag-outlined p-tag-warning" value={data.status}></Tag>
        }

        return (
            component
        );
    };

    const handleMenuClick = (dashboard, menuitem) => {
        console.log("Vue Hebdomadaire sélectionnée");
    };

    const providerBodyTemplate = (data) => {
        return (
            <>
                <span className="p-column-title">Moyen P.</span>
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <img
                        alt=""
                        src="assets/images/logo_orange_money.jpg"
                        style={{height: '20px', marginRight: '0.5rem'}}
                    />
                    <span style={{textTransform: 'capitalize'}}>{data.provider}</span>
                </div>
            </>
        );
    };

    const changeDoughnutDataView = () => {
        if (doughnut.current.chart.options.circumference === Math.PI) {
            doughnut.current.chart.options.circumference = 2 * Math.PI;
            doughnut.current.chart.options.rotation = -Math.PI / 2;
        } else {
            doughnut.current.chart.options.circumference = Math.PI;
            doughnut.current.chart.options.rotation = -Math.PI;
        }

        doughnut.current.chart.update();
    }



    const formatCurrency = (value) => {
        return value.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
    };

    return (
        <div className="p-grid dashboard">
            <div className="p-col-12 p-md-6 p-lg-4">
                <div className="card overview-box p-d-flex p-flex-column p-pt-2">
                    <div className="p-d-flex p-ai-center muted-text">
                        <h5 className="p-m-0 p-pl-2">Solde</h5>
                        <Button type="button" label="Details"
                                className="p-button-text p-ml-auto"
                                onClick={changeMonthlyDataView}></Button>
                    </div>

                    <div className="p-d-flex p-flex-column p-flex-lg-row p-jc-between p-mt-3 p-flex-wrap p-gap-3">
                        <div className="p-d-flex p-flex-column"
                             style={{flex: '1 1 100%', flexBasis: '33.333%', maxWidth: '100%'}}>
                            <span className="p-mb-2 fs-xxlarge">$640</span>
                            <Tag className="fs-normal" severity="info" value="budget prévisionnel"></Tag>
                        </div>
                        <div
                            className="p-d-flex p-ai-end p-mt-3 p-pt-md-4 p-pl-lg-4"
                            style={{flex: '1 1 100%', flexBasis: '66.666%', maxWidth: '100%'}}
                        >
                            <div className="right p-d-flex p-flex-column" style={{width: '100%'}}>
                                <span className="value p-mb-1">solde disponible: $10.000</span>
                                <ProgressBar value="23" style={{height: '10px'}} showValue={false}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="p-col-12 p-md-6 p-lg-4">
                <div className="card overview-box p-d-flex p-flex-column p-pt-2">
                    <div className="p-d-flex p-ai-center muted-text">
                        <h5 className="p-m-0 p-pl-2">Chiffre d'Affaires</h5>
                        <div className="p-ml-auto">
                            <Button type="button" icon="pi pi-ellipsis-h"
                                    className="p-button-rounded p-button-text p-button-plain"
                                    onClick={(event) => menuRevenues.current.toggle(event)}></Button>
                            <Menu ref={menuRevenues} popup model={[
                                {label: 'Journalier', command: () => handleMenuClick('ddd', 'rrr')},
                                {label: 'Hebdomadaire', command: () => handleMenuClick('ddd', 'rrr')},
                                {label: 'Mensuel', command: () => handleMenuClick('ddd', 'rrr')},
                                {label: 'Annuel', command: () => handleMenuClick('ddd', 'rrr')},
                            ]}></Menu>
                        </div>
                    </div>

                    <div className="p-d-flex p-flex-column p-flex-lg-row p-jc-between p-mt-4 p-flex-wrap p-gap-3">
                        <div className="p-d-flex p-flex-column"
                             style={{flex: '1 1 100%', flexBasis: '33.333%', maxWidth: '100%'}}>
                            <span className="p-mb-1 fs-xlarge">
                                <i className="fw-700 fs-large pi p-pr-1 pi-arrow-up green-color"></i>
                                $ 566
                                <span className="fw-500 fs-normal p-ml-1 green-color">
                                    +910
                                </span>
                            </span>
                            <Tag className="fs-normal" severity="success" value="$1420 disponible"></Tag>
                        </div>

                        <div className="p-d-flex p-flex-column p-pt-md-3 p-pl-lg-4"
                             style={{flex: '1 1 100%', flexBasis: '66.666%', width: '100%'}}>
                            <Chart type="line" data={overviewChartData1} options={overviewChartOptions}
                                   height="60px"></Chart>
                        </div>
                    </div>
                </div>
            </div>

            <div className="p-col-12 p-md-6 p-lg-4">
                <div className="card overview-box p-d-flex p-flex-column p-pt-2">
                    <div className="p-d-flex p-ai-center muted-text">
                        <h5 className="p-m-0 p-pl-2">Transactions</h5>
                        <div className="p-ml-auto">
                            <Button type="button" icon="pi pi-ellipsis-h"
                                    className="p-button-rounded p-button-text p-button-plain"
                                    onClick={(event) => menuTransactions.current.toggle(event)}></Button>
                            <Menu ref={menuTransactions} popup model={[
                                {label: 'Journalier', command: () => handleMenuClick('ddd', 'rrr')},
                                {label: 'Hebdomadaire', command: () => handleMenuClick('ddd', 'rrr')},
                                {label: 'Mensuel', command: () => handleMenuClick('ddd', 'rrr')},
                                {label: 'Annuel', command: () => handleMenuClick('ddd', 'rrr')},
                            ]}></Menu>
                        </div>
                    </div>

                    <div className="p-d-flex p-flex-column p-flex-lg-row p-jc-between p-mt-4 p-flex-wrap p-gap-3">
                        <div className="p-d-flex p-flex-column"
                             style={{flex: '1 1 100%', flexBasis: '33.333%', maxWidth: '100%'}}>
                            <span className="p-mb-1 fs-xlarge">
                                <i className="fw-700 fs-large pi p-pr-1"></i>
                                $5644
                                <span className="fw-500 fs-normal p-ml-1 pink-color">
                                   -450
                                </span>
                            </span>
                            <Tag className="fs-normal" severity="warning" value="$1420 validés"></Tag>
                        </div>

                        <div className="p-d-flex p-flex-column p-pt-md-3 p-pl-lg-4"
                             style={{flex: '1 1 100%', flexBasis: '66.666%', width: '100%'}}>
                            <Chart type="line" data={overviewChartData1} options={overviewChartOptions}
                                   height="60px"></Chart>
                        </div>
                    </div>
                </div>
            </div>

            <div className="p-col-12 p-md-8">
                <div className="card height-100">
                    <div className="card-header">
                        <h5>Monthly Comparison</h5>
                        <Button type="button" label="Vertical/Stacked Data"
                                className="p-button-text p-ml-auto"
                                onClick={changeMonthlyDataView}></Button>
                    </div>

                    <Chart ref={bar} type="bar" data={chartMonthlyData} options={chartMonthlyOptions}
                           responsive="true"
                           height="400px"></Chart>
                </div>
            </div>

            <div className="p-col-12 p-md-4">
                <div className="card widget-insights height-100">
                    <div className="card-header p-mb-2">
                        <h5>Insights</h5>
                    </div>
                    <div className="card-subheader p-mb-2 p-d-flex p-ai-center">
                        <span>November 22 - November 29</span>
                        <Button type="button" label="Semi/Full Data"
                                className="p-button-text p-ml-auto"
                                onClick={changeDoughnutDataView}></Button>
                    </div>
                    <Chart ref={doughnut} type="doughnut" data={doughnutData} options={doughnutOptions}
                           responsive="true"></Chart>
                    <div className="p-d-flex p-flex-column p-jc-center">
                        <div className="p-d-flex p-flex-row p-ai-center p-mt-4 p-px-3">
                            <i className="pi pi-thumbs-up p-p-3 rounded-circle lightgreen-bgcolor solid-surface-text-color"></i>
                            <div className="p-d-flex p-flex-column p-ml-3">
                                <span>Best Day of the Week</span>
                                <small>Friday</small>
                            </div>
                            <span className="indigo-color p-ml-auto">95</span>
                        </div>
                        <div className="p-d-flex p-flex-row p-ai-center p-my-4 p-px-3">
                            <i className="pi pi-thumbs-down rounded-circle p-p-3 orange-bgcolor solid-surface-text-color"></i>
                            <div className="p-d-flex p-flex-column p-ml-3">
                                <span>Worst Day of the Week</span>
                                <small>Saturday</small>
                            </div>
                            <span className="indigo-color p-ml-auto"> 6</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="p-col-12 p-lg-6">
                <div className="card height-100">
                    <div className="card-header">
                        <h5>Dernieres transactions</h5>
                        <Button type="button" label="Details"
                                className="p-button-text p-ml-auto"
                                onClick={changeMonthlyDataView}></Button>
                    </div>
                    <DataTable value={transactions} rows={8} className="p-datatable-products"
                               selection={selectedProduct} onSelectionChange={(e) => setSelectedProduct(e.value)}>
                        <Column field="price" body={priceBodyTemplate} header="Montant"/>
                        <Column field="provider" body={providerBodyTemplate} header="Moyen pay."/>
                        <Column field="status" body={statusBodyTemplate} header="Statut"/>
                    </DataTable>
                </div>
            </div>

            <div className="p-col-12 p-lg-6">
                <div className="card height-100">
                    <div className="card-header">
                        <h5>Graphique commande / chiffre d'affaires</h5>
                        <div>
                            <Button type="button" icon="pi pi-ellipsis-h"
                                    className="p-button-rounded p-button-text p-button-plain"
                                    onClick={(event) => menuGraph.current.toggle(event)}></Button>
                            <Menu ref={menuGraph} popup model={[
                                {label: 'Journalier', command: () => handleMenuClick('ddd', 'rrr')},
                                {label: 'Hebdomadaire', command: () => handleMenuClick('ddd', 'rrr')},
                                {label: 'Mensuel', command: () => handleMenuClick('ddd', 'rrr')},
                                {label: 'Annuel', command: () => handleMenuClick('ddd', 'rrr')},
                            ]}></Menu>
                        </div>
                    </div>
                    <Chart type="line" data={ordersChart} options={ordersOptions}></Chart>
                </div>
            </div>
        </div>

    )
}
